import config from '../config';
import http from '@/utils/http';
import { logger } from '@/utils/screenEventsLogger';

export async function apiGetScreenLayout(screenId) {
  try {
    const endpoint = `${config.apiUrl}userapi/screens/${screenId}/layout`;

    return await http.get(endpoint);
  } catch (error) {
    logger.addLog(`Screen's Layout API failed for screen ${screenId}: ${error?.message || 'NA'}`);
    return null;
  }
}

export async function apiGetScreenLayoutChildren(screenId) {
  try {
    return await http.get(`${config.apiUrl}userapi/screens/${screenId}/layout/children`);
  } catch (error) {
    logger.addLog(`Layout's children API failed for screen ${screenId}: ${error?.message || 'NA'}`);
    return null;
  }
}

export async function apiGetScreenLayoutMediaAsset(screenId) {
  const response = await http.get(`${config.apiUrl}userapi/screens/${screenId}/layout/media-asset`);

  return response.data;
}
